module.exports = __webpack_public_path__ + "static/media/Harvel.947900f4.md";